import * as React from "react";

import { cn } from "@/lib/utils";

type TextareaProps = React.ComponentPropsWithRef<"textarea">;

// Keep mobile text at 16px, including transparent mention inputs and their overlays.
export const textareaClassName =
  "flex min-h-24 w-full rounded-lg border border-transparent bg-control px-2.5 py-2 text-[length:var(--text-body)] transition-colors outline-none hover:bg-muted/70 placeholder:text-placeholder disabled:cursor-not-allowed disabled:opacity-60 md:text-sm";

function Textarea({ className, ref, ...props }: TextareaProps) {
  return (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(textareaClassName, className)}
      {...props}
    />
  );
}

export { Textarea };
